/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** write-controller */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** write-controller 删除草稿邮件 */
export async function deleteDraftEmailGet(
  payload: {
    contactId: string;
    contentId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/gator/api/biz/gator/write/draft/delete`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller 新增&更新草稿邮件 */
export async function editDraftEmailPost(payload: model.IApiDraftEmailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/gator/api/biz/gator/write/draft/edit`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 获取草稿邮件 */
export async function getDraftEmailGet(
  payload: {
    contactId: string;
    contentId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultCommsEmailDetailResp>({
    url: `/gator/api/biz/gator/write/draft/email`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller 草稿邮件列表 */
export async function getDraftListPost(payload: model.IApiDraftEmailListReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultDraftEmailListResp>({
    url: `/gator/api/biz/gator/write/draft/list`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller editEmail */
export async function editEmailPost(payload: model.IApiDraftEmailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/gator/api/biz/gator/write/editEmail`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 获取退订连接 */
export async function writeGetUnsubscribeUrlGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultUnsubscribeGetUrlResp>({
    url: `/gator/api/biz/gator/write/getUnsubscribeUrl`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** write-controller regenerate */
export async function regenerateGet(
  payload: {
    feedback: string;
    recordId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultCommsFlowEmailOperateResp>({
    url: `/gator/api/biz/gator/write/regenerate`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller renewUrl */
export async function renewUrlPost(
  payload: {
    nosKeys: Array<string>;
  },
  options?: RequestOptions
) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultListUrlResult>({
    url: `/gator/api/biz/gator/write/renewURL`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 保存邮件设置 */
export async function saveEmailSettingPost(payload: model.IApiEmailSettingReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/gator/api/biz/gator/write/save/email/setting`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller sendEmail */
export async function sendEmailPost(payload: model.IApiSendEmailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/gator/api/biz/gator/write/sendEmail`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 获取签名 */
export async function getSignatureGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultstring>({
    url: `/gator/api/biz/gator/write/signature`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** write-controller taskAbort */
export async function taskAbortGet(
  payload: {
    taskId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/gator/api/biz/gator/write/task/abort`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller taskApprove */
export async function taskApproveGet(
  payload: {
    taskId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/gator/api/biz/gator/write/task/approve`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller taskApproveAll */
export async function taskApproveAllGet(
  payload: {
    contactId?: string;
    taskType: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/gator/api/biz/gator/write/task/approve/all`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller taskDetails */
export async function taskDetailsGet(
  payload: {
    taskId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultCommsEmailDetailResp>({
    url: `/gator/api/biz/gator/write/task/details`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller taskRetry */
export async function taskRetryGet(
  payload: {
    taskId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultCommsFlowEmailOperateResp>({
    url: `/gator/api/biz/gator/write/task/retry`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/**
 * @deprecated
 * write-controller taskStop
 */
export async function taskStopGet(
  payload: {
    taskId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/gator/api/biz/gator/write/task/stop`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller uploadFiles */
export async function uploadFilesPost(
  payload: {
    contentType?: string;
    file: File;
    relatedId: string;
    uploadType?: string;
  },
  options?: RequestOptions
) {
  const params = Object.assign(
    {},
    { contentType: payload.contentType },
    { relatedId: payload.relatedId },
    { uploadType: payload.uploadType }
  );
  const data: any = new FormData();
  data.append('file', payload.file);

  const result = await http.request<model.IApiJsonResultUrlResult>({
    url: `/gator/api/biz/gator/write/uploadFile`,
    method: 'post',
    params,
    data,
    ...options,
  });

  return result.data;
}
